import React from 'react';

const OPTIONS = [
  { id: 'openai', label: 'ChatGPT' },
  { id: 'anthropic', label: 'Claude' },
];

export const ProviderToggle = ({ value, onChange, disabled }) => (
  <div className="inline-flex rounded-full bg-gray-100 p-1" role="radiogroup" data-testid="ai-provider-toggle">
    {OPTIONS.map((o) => (
      <button
        key={o.id}
        type="button"
        role="radio"
        aria-checked={value === o.id}
        disabled={disabled}
        onClick={() => onChange(o.id)}
        data-testid={`ai-provider-${o.id}`}
        className={`px-4 py-1.5 text-sm font-semibold rounded-full transition-colors duration-200 disabled:opacity-50 ${
          value === o.id ? 'bg-white text-purple-700 shadow-sm' : 'text-gray-500 hover:text-gray-800'
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export const providerLabel = (id) => OPTIONS.find((o) => o.id === id)?.label || id;
